<div *ngIf="!loadingRoutesInfo" class="card-display">
    <p-card>
        <h2><b>{{ "Routes Info" | translate}}</b></h2>
        <ul class="info-list">
            <li>
                <div class="customer-info-li">
                    <h5><b>{{ "Credits" | translate }} : </b></h5>
                    <span>{{ customerInfo.credit }}</span>
                </div>
            </li>
            <li>
                <div class="customer-info-li">
                    <h5><b>{{ "Last Credit Charge" | translate }} : </b></h5>
                    <span>{{ formatDate(customerInfo.lastCreditChange) }}</span>
                </div>
            </li>
            <hr>
            <div class="p-inputgroup" *ngIf="isRoutesEnabled === true">
                <span class="p-inputgroup-addon">
                    {{ "Add Credits" | translate }}
                </span>
                <input type="number" min="1" pInputText placeholder="Credits" [(ngModel)]="creditsToAdd"/>
                <div>
                    <button class="add-credits-button" (click)="addCredits(100)"  type="button" pButton id="add-100-credit"><b>+100</b></button>
                    <button class="add-credits-button" (click)="addCredits(1000)" type="button" pButton id="add-1000-credit"><b>+1000</b></button>
                    <button class="add-credits-button-total" (click)="addCredits()" type="button" pButton icon="pi pi-plus-circle"></button>
                </div>

                <p-toast></p-toast>
                <p-confirmDialog [style]="{width: '50vw'}"></p-confirmDialog>
            </div>
        </ul>
    </p-card>
    
</div>